<script setup lang="ts">
    import type { FachkreisRequiredField } from '~/types/censhare/fachkreisValidation';

    defineProps<{
        missingFields: FachkreisRequiredField[];
    }>();

    const fieldLabelKeys: Record<FachkreisRequiredField, string> = {
        pharmacyOnly: 'product.tabs.tabContent.pharmacy',
        prescriptionOnly: 'product.tabs.tabContent.prescription',
        brand: 'product.tabs.tabContent.brand',
        dosageForm: 'product.tabs.tabContent.dosage',
        indication: 'product.tabs.tabContent.indication',
        applicationArea: 'product.tabs.tabContent.applicationArea',
        countryOfDistribution: 'product.validation.countryOfDistribution'
    };

    const pluralizedFields: FachkreisRequiredField[] = ['indication', 'applicationArea'];
</script>

<template>
    <Note
        type="warning"
        class="draft-validation-message"
    >
        <h1>{{ $t('product.validation.headline') }}</h1>
        <p>{{ $t('product.validation.text') }}</p>
        <p>{{ $t('product.validation.missingFields') }}</p>
        <ul>
            <li
                v-for="field in missingFields"
                :key="field"
            >
                {{ $t(fieldLabelKeys[field], pluralizedFields.includes(field) ? 2 : 1) }}
            </li>
        </ul>
    </Note>
</template>

<style lang="scss" scoped>
    .draft-validation-message {
        margin: 2rem 0 4rem;

        h1 {
            margin-bottom: 1rem;
            font-size: $font-m;
            font-weight: bold;
        }

        p + p {
            margin-top: 1rem;
        }

        ul {
            margin: 1rem 0 0;
            padding-left: 1.25rem;
        }

        li {
            list-style: initial;
        }
    }
</style>
